import { useState, useRef } from 'react';
import DropdownMenuPortal from './DropdownMenuPortal';
import { IoChevronDownOutline } from 'react-icons/io5';

type Props = {
  rowData: { _taskId: number; employeeId?: string | number; label?: string };
  employees: Array<{ id: number | string; firstName: string; lastName: string }>;
  intl: any;
  onChange: (rowData: Props['rowData'], value: string | number | '') => void;
};

export default function TeamMemberInline({ rowData, employees = [], intl, onChange }: Props) {
  const [open, setOpen] = useState(false);
  const btnRef = useRef<HTMLButtonElement | null>(null);

  const toggle = () => setOpen((v) => !v);
  const choose = (value: string | number | '') => {
    setOpen(false);
    if (value !== rowData.employeeId) onChange(rowData, value);
  };

  const selected = employees.find((e) => String(e.id) === String(rowData.employeeId));
  const unassignedText = intl.formatMessage({ id: 'unassigned', defaultMessage: 'Unassigned' });
  const currentLabel =
    rowData.label || (selected ? `${selected.lastName}, ${selected.firstName}` : unassignedText);

  return (
    <div className="inline-select" style={{ position: 'relative', display: 'inline-block' }}>
      <button
        type="button"
        className="btn btn-link p-0"
        ref={btnRef}
        onClick={(e) => {
          e.stopPropagation();
          toggle();
        }}
        aria-haspopup="listbox"
        aria-expanded={open}
        style={{
          fontSize: 'inherit',
          textDecoration: 'none',
          width: '100%',
          textAlign: 'left',
          color: selected ? '#1f2937' : '#94a3b8',
        }}
      >
        {currentLabel}
        <IoChevronDownOutline />
      </button>
      <DropdownMenuPortal
        anchorRef={btnRef as any}
        open={open}
        onClose={() => setOpen(false)}
        minWidth={200}
      >
        <button
          type="button"
          className={`dropdown-item${!rowData.employeeId ? ' active' : ''}`}
          onClick={(e) => {
            e.stopPropagation();
            choose('');
          }}
        >
          {unassignedText}
        </button>
        {employees.map((opt) => (
          <button
            key={opt.id}
            type="button"
            className={`dropdown-item${
              String(opt.id) === String(rowData.employeeId) ? ' active' : ''
            }`}
            onClick={(e) => {
              e.stopPropagation();
              choose(opt.id);
            }}
          >
            {`${opt.lastName}, ${opt.firstName}`}
          </button>
        ))}
      </DropdownMenuPortal>
    </div>
  );
}
